export default "/images/why_work_with_us/why_work_with_us.png";